import { IPricingData } from '@models/IPricingData';
import classNames from 'classnames';

interface Props {
  readonly centerText?: boolean;
  readonly fromPriceLabel?: string;
  readonly pricingData: IPricingData;
  readonly vatLabel?: string;
  readonly shippingLabel?: string;
  readonly rrpLabel?: string;
  readonly smallText?: boolean;
  readonly containerClassName?: string;
  readonly taxesTopMarginClassName?: string;
  readonly taxesClassName?: string;
  readonly priceClassName?: string;
  readonly dataTestId?: string;
  readonly isLightMode?: boolean;
}

const PriceDisplayText = ({
  fromPriceLabel,
  pricingData,
  vatLabel,
  shippingLabel,
  rrpLabel,
  centerText = false,
  smallText = false,
  containerClassName,
  taxesTopMarginClassName = 'mt-2',
  taxesClassName,
  priceClassName,
  dataTestId,
  isLightMode,
}: Props) => {
  const {
    amountSaved,
    formattedPrice,
    formattedCalculatedPrice,
    shippingCost,
    price,
  } = pricingData;

  if (typeof price !== 'number') {
    return null;
  }

  return (
    <div
      className={classNames(
        containerClassName,
        smallText ? 'body-two font-light' : 'body-one',
        {
          'flex flex-col items-center': centerText,
        }
      )}
      data-testid={dataTestId}
    >
      {(centerText ||
        (amountSaved > 0 && formattedPrice) ||
        formattedCalculatedPrice) && (
        <span className="flex flex-wrap gap-x-2">
          {fromPriceLabel && <span>{fromPriceLabel}</span>}

          {amountSaved > 0 && formattedPrice && (
            <>
              {rrpLabel && <span className="mr-2">{rrpLabel}</span>}
              <span
                className="font-extralight line-through decoration-1"
                data-testid="Price-Display-Text-Discount-Price"
              >
                {formattedPrice}
              </span>
            </>
          )}

          {formattedCalculatedPrice && (
            <span
              className={classNames(
                {
                  'font-normal': !smallText,
                  'text-grey-450': amountSaved > 0,
                  'dark:text-yellow': amountSaved > 0 && !isLightMode,
                },
                priceClassName
              )}
              data-testid="Price-Display-Text-Price"
            >
              {formattedCalculatedPrice}
            </span>
          )}
        </span>
      )}

      {(vatLabel || (!shippingCost && shippingLabel)) && (
        <p
          className={classNames(taxesClassName, 'body-four block', {
            [`${taxesTopMarginClassName}`]: !smallText,
          })}
          data-testid="Price-Display-Text-VAT/Shipping"
        >
          {vatLabel && vatLabel}
          {vatLabel && !shippingCost && shippingLabel && ' + '}
          {!shippingCost && shippingLabel && shippingLabel}
        </p>
      )}
    </div>
  );
};

export default PriceDisplayText;
